import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(VueRouter)

export const constantRoutes = [
  { path: '/login', name: 'Login', component: () => import('@/views/login/index.vue'), meta: { title: '登录', hidden: true } },
  { path: '/404', name: '404', component: () => import('@/views/error/404.vue'), meta: { title: '404', hidden: true } },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    meta: { hidden: true },
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect',
        component: () => import('@/views/redirect/index.vue'),
        meta: { hidden: true }
      }
    ]
  },
  // 控制台常驻：避免权限过滤后无首页，陷入 /* → /404 死循环
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '控制台', icon: 'el-icon-s-home', affix: true, permission: 'dashboard:view' }
      }
    ]
  }
]

export const asyncRoutes = [
  {
    path: '/content', component: Layout, redirect: '/content/banner', meta: { title: '内容运营', icon: 'el-icon-picture-outline' },
    children: [
      { path: 'banner', name: 'ContentBanner', component: () => import('@/views/business/banner/index.vue'), meta: { title: '轮播图管理', icon: 'el-icon-picture', permission: 'content:banner' } },
      { path: 'category', name: 'ContentCategory', component: () => import('@/views/business/category/index.vue'), meta: { title: '游戏分类', icon: 'el-icon-collection', permission: 'content:category' } },
      { path: 'service', name: 'ContentService', component: () => import('@/views/business/service/index.vue'), meta: { title: '服务产品', icon: 'el-icon-goods', permission: 'content:service' } },
      { path: 'service-edit', name: 'ContentServiceEdit', component: () => import('@/views/business/service/edit.vue'), hidden: true, meta: { title: '编辑服务产品', hidden: true, permission: 'content:service' } },
      { path: 'announcement', name: 'ContentAnnouncement', component: () => import('@/views/operation/announcement/index.vue'), meta: { title: '消息通知', icon: 'el-icon-bell', permission: 'content:announcement' } },
      { path: 'kingkong', name: 'ContentKingkong', component: () => import('@/views/operation/kingkong/index.vue'), meta: { title: '首页金刚区', icon: 'el-icon-menu', permission: 'content:kingkong' } },
      { path: 'coupon', name: 'ContentCoupon', component: () => import('@/views/operation/coupon/index.vue'), meta: { title: '优惠券管理', icon: 'el-icon-s-ticket', permission: 'content:coupon' } },
      { path: 'guide', name: 'ContentGuide', component: () => import('@/views/operation/guide/index.vue'), meta: { title: '新手须知', icon: 'el-icon-document', permission: 'content:guide' } },
      { path: 'customer-service', name: 'ContentCustomerService', component: () => import('@/views/operation/customerService/index.vue'), hidden: true, meta: { title: '客服管理', icon: 'el-icon-service', hidden: true, permission: 'content:announcement' } },
      { path: 'feedback', name: 'ContentFeedback', component: () => import('@/views/operation/feedback/index.vue'), meta: { title: '意见反馈', icon: 'el-icon-edit-outline', permission: 'content:feedback' } }
    ]
  },
  {
    path: '/order-center', component: Layout, redirect: '/order-center/order', meta: { title: '订单中心', icon: 'el-icon-s-order' },
    children: [
      { path: 'order', name: 'OrderCenterOrder', component: () => import('@/views/business/order/index.vue'), meta: { title: '订单管理', icon: 'el-icon-document', permission: 'order:order' } },
      { path: 'order-detail', name: 'OrderCenterOrderDetail', component: () => import('@/views/business/order/detail.vue'), hidden: true, meta: { title: '订单详情', permission: 'order:order' } },
      { path: 'appeal', name: 'OrderCenterAppeal', component: () => import('@/views/operation/appeal/index.vue'), meta: { title: '申诉管理', icon: 'el-icon-warning', permission: 'order:appeal' } },
      { path: 'rating', name: 'OrderCenterRating', component: () => import('@/views/business/rating/index.vue'), meta: { title: '评价管理', icon: 'el-icon-star-off', permission: 'order:rating' } },
      { path: 'rating-tag', name: 'OrderCenterRatingTag', component: () => import('@/views/operation/ratingTag/index.vue'), meta: { title: '评价标签', icon: 'el-icon-price-tag', permission: 'order:ratingTag' } }
    ]
  },
  {
    path: '/user-center', component: Layout, redirect: '/user-center/user', meta: { title: '用户中心', icon: 'el-icon-user-solid' },
    children: [
      { path: 'user', name: 'UserCenterUser', component: () => import('@/views/business/user/index.vue'), meta: { title: '用户列表', icon: 'el-icon-user', permission: 'user:user' } },
      { path: 'invite-tree', name: 'UserCenterInviteTree', component: () => import('@/views/operation/inviteTree/index.vue'), meta: { title: '推荐关系树', icon: 'el-icon-share', permission: 'user:inviteTree' } },
      { path: 'invite-commission', name: 'UserCenterInviteCommission', component: () => import('@/views/operation/inviteCommission/index.vue'), meta: { title: '邀请佣金记录', icon: 'el-icon-money', permission: 'user:inviteCommission' } },
      { path: 'realname', name: 'UserCenterRealname', component: () => import('@/views/operation/realname/index.vue'), meta: { title: '实名审核', icon: 'el-icon-postcard', permission: 'user:realname' } },
      { path: 'finance', name: 'UserCenterFinance', component: () => import('@/views/operation/userFinance/index.vue'), meta: { title: '用户财务', icon: 'el-icon-wallet', permission: 'user:finance' } }
    ]
  },
  {
    path: '/driver-center', component: Layout, redirect: '/driver-center/driver', meta: { title: '打手中心', icon: 'el-icon-s-cooperation' },
    children: [
      { path: 'driver', name: 'DriverCenterDriver', component: () => import('@/views/business/driver/index.vue'), meta: { title: '打手列表', icon: 'el-icon-s-custom', permission: 'driver:driver' } },
      { path: 'driver-detail', name: 'DriverCenterDriverDetail', component: () => import('@/views/business/driver/detail.vue'), hidden: true, meta: { title: '打手详情', permission: 'driver:driver' } },
      { path: 'apply', name: 'DriverCenterApply', component: () => import('@/views/business/driverApply/index.vue'), meta: { title: '入驻审核', icon: 'el-icon-s-check', permission: 'driver:apply' } },
      { path: 'driver-announcement', name: 'DriverCenterAnnouncement', component: () => import('@/views/operation/driverAnnouncement/index.vue'), meta: { title: '接单公告', icon: 'el-icon-message', permission: 'driver:announcement' } },
      { path: 'driver-report', name: 'DriverCenterReport', component: () => import('@/views/operation/driverReport/index.vue'), meta: { title: '打手举报', icon: 'el-icon-warning-outline', permission: 'driver:report' } },
      { path: 'withdraw', name: 'DriverCenterWithdraw', component: () => import('@/views/business/withdraw/index.vue'), meta: { title: '提现管理', icon: 'el-icon-money', permission: 'driver:withdraw' } }
    ]
  },
  {
    path: '/system', component: Layout, redirect: '/system/basic', meta: { title: '系统管理', icon: 'el-icon-setting' },
    children: [
      { path: 'basic', name: 'SystemBasic', component: () => import('@/views/system/basic/index.vue'), meta: { title: '基本配置', icon: 'el-icon-s-tools', permission: 'system:basic' } },
      { path: 'wechat', name: 'SystemWechat', component: () => import('@/views/system/wechat/index.vue'), meta: { title: '微信与短信', icon: 'el-icon-chat-dot-round', permission: 'system:wechat' } },
      { path: 'notify', name: 'SystemNotify', component: () => import('@/views/system/notify/index.vue'), meta: { title: '消息通知配置', icon: 'el-icon-message-solid', permission: 'system:notify' } },
      { path: 'admin-user', name: 'SystemAdminUser', component: () => import('@/views/system/admin/index.vue'), meta: { title: '管理员', icon: 'el-icon-user', permission: 'system:adminUser' } },
      { path: 'role', name: 'SystemRole', component: () => import('@/views/system/role/index.vue'), meta: { title: '角色管理', icon: 'el-icon-s-custom', permission: 'system:role' } },
      { path: 'permission', name: 'SystemPermission', component: () => import('@/views/system/permission/index.vue'), meta: { title: '菜单权限', icon: 'el-icon-menu', permission: 'system:permission' } },
      { path: 'maintain', name: 'SystemMaintain', component: () => import('@/views/system/maintain/index.vue'), meta: { title: '系统维护', icon: 'el-icon-warning-outline', permission: 'system:maintain' } },
      // 兼容旧路由
      { path: 'admin', redirect: '/system/admin-user', hidden: true, meta: { hidden: true } }
    ]
  },
  {
    path: '/log', component: Layout, redirect: '/log/admin', meta: { title: '日志管理', icon: 'el-icon-document' },
    children: [
      { path: 'admin', name: 'LogAdmin', component: () => import('@/views/log/admin/index.vue'), meta: { title: '后台日志', icon: 'el-icon-notebook-2', permission: 'log:admin' } },
      { path: 'user', name: 'LogUser', component: () => import('@/views/log/user/index.vue'), meta: { title: '用户日志', icon: 'el-icon-mobile-phone', permission: 'log:user' } },
      { path: 'driver', name: 'LogDriver', component: () => import('@/views/log/driver/index.vue'), meta: { title: '打手日志', icon: 'el-icon-phone', permission: 'log:driver' } }
    ]
  },
  { path: '/order-center/platform', redirect: '/system/basic', hidden: true },
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new VueRouter({ mode: 'history', scrollBehavior: () => ({ y: 0 }), routes: constantRoutes })
const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
  router.options.routes = constantRoutes.slice()
  router.__adminRoutesReady = false
}

export default router
